import { z } from "zod";
import { zDisplayId } from "./ZDisplayId";
import { zUid } from "./zUid";

/**
 * Соответствует ObjectNameDto в сваггере (GET /ms-object/api/v3/objects).
 *
 * Облегчённое описание объекта для построения корневых узлов дерева Управления.
 * Не содержит ни атрибутов, ни групп, ни полного списка permissions: из прав
 * приходят флаги canUpdate (наличие OBJECT_UPDATE) и canDelete (OBJECT_DELETE).
 *
 * canDelete пока присылает не всякий сервер, поэтому его отсутствие означает
 * "неизвестно" и трактуется как запрет: удаление объекта откроется после
 * загрузки его данных. Как только поле появится в ответе, кнопка удаления
 * заработает сразу, без правок здесь.
 *
 * Это НЕ ZObjectItem. Схемы намеренно разделены, чтобы состояние
 * "детали ещё не загружены" нельзя было спутать с "детали загружены и пусты".
 */
export const zObjectSummary = z.object({
  id: zUid,
  displayId: zDisplayId,
  name: z.string(),
  canUpdate: z.boolean(),
  canDelete: z.boolean().default(false),
});

export type ZObjectSummary = z.infer<typeof zObjectSummary>;
